import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import List from './list.vue'
import Layout from '../layout.vue'

const basePath = '/v-admin/audit-log/management'

export default {
  name: 'auditLogManagement',
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: 'PERM_ADMIN_USER',
    titleI18nKey: 'admin.company.auditLogManagement.title.auditLogManagement',
    menu: {
      get label () {
        return i18n.t('admin.company.auditLogManagement.menu')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.COMPANY_INTERNAL
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: List,
      meta: {
        isNewPage: true,
        breadcrumb: { hidden: true },
        titleI18nKey: 'admin.company.auditLogManagement.title.auditLogManagement'
      }
    }
  ]
}
